"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";

import { pathInCurrentLocale } from "@/lib/i18n/current-locale-path";

/**
 * Replaces the current history entry with `path`, in the language the shopper
 * is browsing, once `when` is true.
 *
 * A replace, not a push: the page being left is one this store does not offer
 * (a cart it skips, a login it has switched off), so Back must not land on it
 * and bounce the shopper forward again.
 */
export function useLocaleRedirect(when: boolean, path: string): void {
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (when) router.replace(pathInCurrentLocale(path, pathname));
  }, [when, path, pathname, router]);
}
